import { config } from "../config";
const REGIONS = {
    US: {
        code: "US",
        name: "United States",
        domain: "bryx911.com",
        flag: "🇺🇸",
    },
    CA: {
        code: "CA",
        name: "Canada",
        domain: "bryx911.ca",
        flag: "🇨🇦",
    },
};
function isDevelopmentEnvironment(hostname = window.location.hostname) {
    return hostname.includes("localhost") || hostname.includes("dev.bryx");
}
export function getCurrentRegion(hostname = window.location.hostname) {
    return hostname.includes(REGIONS.CA.domain) ? "CA" : "US";
}
export function getAvailableRegions() {
    return isDevelopmentEnvironment() ? [REGIONS.US] : Object.values(REGIONS);
}
export function getBaseAPIUrl(hostname = window.location.hostname) {
    if (isDevelopmentEnvironment(hostname)) {
        // localhost / dev.bryx911.com -> https://dev.bryx911.com/api/2.2
        return config.baseUrl;
    }
    const domain = REGIONS[getCurrentRegion(hostname)].domain;
    // support.bryx911.com -> https://bryx911.com/api/2.2
    // support.bryx911.ca -> https://bryx911.ca/api/2.2
    return config.baseUrl.replace(REGIONS.US.domain, domain);
}
export function getBaseUrl() {
    const baseAPIUrl = getBaseAPIUrl();
    return baseAPIUrl.replace("/api/2.2", "");
}
export function redirectToRegion(region) {
    if (isDevelopmentEnvironment()) {
        return;
    }
    const { hostname, protocol, pathname, search, hash } = window.location;
    const currentDomain = REGIONS[getCurrentRegion()].domain;
    const targetDomain = REGIONS[region].domain;
    const prefix = hostname.slice(0, hostname.length - currentDomain.length); // e.g. "support.",  "tools-staging."
    const targetHost = `${prefix}${targetDomain}`; // e.g. "support.bryx911.ca", "tools-staging.bryx911.ca"
    window.location.href = `${protocol}//${targetHost}${pathname}${search}${hash}`;
}
